import '../styles/app.scss';

/** Autoload */
import './autoload/vanilla-jq';
import './autoload/_bootstrap';
import './autoload/_fonts';
import fetchInject from 'fetch-inject';
import formToObject from 'form_to_object';
import { debounce } from 'tiny-throttle';

/* Global vars */
window.debounce = debounce;
window.fetchInject = fetchInject;
window.formToObject = formToObject;

/** Util */
import './util/root';
import './util/app-height';
// import './util/app-width';
import './util/current-breakpoint';
import './util/splide-global';
import './util/splide-resize-height-of-slider';
import './util/body-top-padding';
import './util/scrollbar-width';

/** Global */
import './global/header';
import './global/footer';

/**  Components */
import './components/splide-slider';
import './components/dropdown';
import './components/checkbox-radio';
import './components/url-updater';
import './components/filter-tags';
import './components/cta-cards';
import './components/password-input';
import './components/top-hundred';
import './components/category-slider';
import './components/articles-carousel';
import './components/widgets-standings';
import './components/content-single';
import './components/widgets-article';
import './components/widgets-splide';
import './components/live-match-splide';
// import './components/loader';
// import './components/widgets-ads';
import './components/countdown';

/** Modules */
import './blocks/text-plus-media-slider';
import './blocks/tabbed-content';
import './blocks/team-grid';
import './blocks/accordion';
import './blocks/new-password-form';
import './blocks/poll';
import './blocks/video';
import './blocks/gallery';
import './blocks/ads';
import './blocks/achievement';

/** Partials */
import './partials/filters-toggle';
import './partials/fixtures-home';
import './partials/app-banner';
// import './partials/fixtures-arrow';

/** Providers */
import './providers/blaze-stories';

/** Tracking */
import './tracking';

/** Templates */
import './template/static-page';
import './template/archieve';
import './template/top100';
